import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { walletPaymentActions, walletPaymentSelectors } from 'Ducks';
import Input from 'Components/Globals/Elements/Input/loadable';
import Button from 'Components/Globals/Elements/Button';
import Guide from 'Assets/images/payment/Guide.png';
import { composeClassNames } from 'Helpers';
import useContent from 'Hooks/useContent';

import styles from './styles.module.scss';
import strings from './strings';

function ManualBarcode() {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const { formatMessage } = useContent();
	const [barcode, setBarcode] = useState(0);
	const id = useSelector(walletPaymentSelectors.selectTransactionId);

	const onSubmitBarcode = () => {
		dispatch(
			walletPaymentActions.checkBarcodeRequest({
				id,
				barcode,
				navigate,
			})
		);
	};
	return (
		<div className={styles.wrapper}>
			<p className='txt-dark text-center m-16 mt-24'>
				{formatMessage(strings.description)}
			</p>
			<Input
				name='barcode'
				className={composeClassNames(['mv-8 mh-16', styles.input])}
				value={barcode}
				onChange={(value) => setBarcode(value)}
				textCenter
				type='number'
			/>
			<div className='m-16 mt-24'>
				<img
					src={Guide}
					className={styles.guide}
					alt='Guide'
				/>
			</div>
			<Button
				label={formatMessage(strings.buttonLabel)}
				onClick={() => onSubmitBarcode()}
				className={composeClassNames(['m-16', styles.button])}
			/>
		</div>
	);
}

export default ManualBarcode;
